import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '../button';
import { Dialog, DialogTitle, DialogBody } from '../dialog';
import { useOtAcciones, useOtConfig } from '../../hooks/useOrdenesTrabajo';
import { MOTIVO_MAX_LEN, folioTexto, fasesDe, APROBACION_RESULTADOS } from '../../utils/ordenesTrabajo';

const field =
  'w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none ' +
  'focus:border-azul-surelia focus:ring-1 focus:ring-azul-surelia';

/**
 * Approve: nothing to assign (Fran, 2026-10-19: "simplemente se debe
 * aprobar"). The OT moves to the next fase with nobody on it and shows up in
 * the coordinador's "Por asignar".
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {Function} props.onClose
 * @param {Object|null} props.ot
 */
export function OtAprobarDialog({ isOpen, onClose, ot }) {
  const { config } = useOtConfig();
  const { resolverAprobacion } = useOtAcciones();
  const fases = useMemo(() => fasesDe(config, ot?.tipo), [config, ot?.tipo]);
  const idx = fases.findIndex((f) => f.id === ot?.faseId);
  const siguiente = idx >= 0 ? fases[idx + 1] : null;

  const [nota, setNota] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setNota('');
    setError(null);
    setBusy(false);
  }, [isOpen, ot?.id]);

  if (!isOpen || !ot) return null;

  const confirmar = async () => {
    if (!siguiente) { setError('No hay una fase después de esta.'); return; }
    setBusy(true);
    try {
      await resolverAprobacion(ot, { resultado: APROBACION_RESULTADOS.APROBADA, faseId: siguiente.id, asignados: [], nota });
      onClose();
    } catch (e) {
      console.error('aprobar failed', e);
      setError(e.message || 'No se pudo guardar.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onClose={busy ? () => {} : onClose} size="sm">
      <DialogTitle><span className="text-azul-surelia">Aprobar {folioTexto(ot.folio)}</span></DialogTitle>
      <DialogBody>
        <div className="space-y-3">
          <div className="text-sm text-zinc-700">
            {ot.titulo}
            {siguiente && <div className="text-xs text-zinc-500 mt-0.5">Avanza a {siguiente.nombre}, sin responsable todavía.</div>}
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Nota (opcional)</label>
            <textarea rows={2} value={nota} maxLength={MOTIVO_MAX_LEN} onChange={(e) => setNota(e.target.value)} className={field} autoFocus />
          </div>
          {error && <div className="rounded-lg bg-red-50 border border-red-200 px-3 py-2 text-xs text-red-700">{error}</div>}
          <div className="flex justify-end gap-2 pt-1">
            <Button plain onClick={onClose} disabled={busy}>Cancelar</Button>
            <Button color="surelia" onClick={confirmar} disabled={busy || !siguiente}>{busy ? 'Guardando…' : 'Aprobar'}</Button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  );
}

export default OtAprobarDialog;
